module.exports = __webpack_public_path__ + "static/media/portfolio-pic-01.54253dcc.png";